import Reveal from "@/components/Reveal";

/**
 * The Crossing — horizontal 10-12 week timeline with dashed connector.
 */
const weeks = [
  {
    no: "Weeks 1–3 · Foundations",
    t: "Papers in order",
    b: "EU account and Brand Registry set up. VAT registered through the One Stop Shop. Compliance assembled for every product — labelling, safety, category rules.",
  },
  {
    no: "Weeks 4–5 · Listings",
    t: "Built to convert",
    b: "German and French listings written by people who know the categories — titles, bullets, A+ content, Brand Store. Not machine-translated.",
  },
  {
    no: "Weeks 6–7 · Stock moves",
    t: "Customs-free crossing",
    b: "FBA shipment planned and booked, Ireland to Amazon's EU network. Prime-eligible the moment it's received.",
  },
  {
    no: "Weeks 8–12 · Live",
    t: "First sales, then rank",
    b: "Listings on, advertising on, early reviews building. Weekly optimisation until organic rankings appear — then the channel compounds.",
  },
];

export default function Crossing() {
  return (
    <section className="bg-paper text-ink border-b border-line" data-testid="the-crossing">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10 py-16 sm:py-20 lg:py-24">
        <Reveal>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-coral flex items-center gap-3.5 mb-5">
            <span className="w-9 h-px bg-coral" />
            Chapter 04 — The crossing
          </p>
          <h2 className="font-serif-i italic text-[34px] sm:text-[44px] lg:text-[64px] leading-[.98] tracking-[-.035em] max-w-[880px] mb-6 text-ink">
            Ten to twelve weeks.
            <br />
            One <em className="text-navy-mid">operator.</em>
          </h2>
          <p className="text-[16px] font-light leading-[1.78] max-w-[600px] mb-14 text-ink-muted">
            No account managers, no handoffs, no six specialists between you and the work.{" "}
            <strong className="text-ink font-medium">
              The person who assessed your brand is the person who launches it
            </strong>{" "}
            — and the person who answers your message.
          </p>
        </Reveal>

        {/* Horizontal weeks grid */}
        <Reveal>
          <div className="relative grid grid-cols-1 md:grid-cols-4 border border-line bg-white">
            {/* Dashed connector line (desktop only) */}
            <div
              aria-hidden="true"
              className="hidden md:block absolute z-0"
              style={{
                top: 54,
                left: "6%",
                right: "6%",
                borderTop: "2px dashed #DDD8CE",
              }}
            />
            {weeks.map((w, i) => (
              <div
                key={i}
                data-testid={`crossing-wk-${i}`}
                className="relative z-10 px-7 pt-9 pb-10 border-b md:border-b-0 md:border-r border-line last:border-r-0 last:border-b-0"
              >
                <div
                  className={`w-[13px] h-[13px] rounded-full mb-6 relative z-20 border-[2.5px] border-coral ${
                    i === weeks.length - 1 ? "bg-coral" : "bg-white"
                  }`}
                />
                <p className="font-mono text-[9.5px] tracking-[0.2em] uppercase text-coral mb-2.5">
                  {w.no}
                </p>
                <p className="text-[15px] font-semibold text-ink mb-2">{w.t}</p>
                <p className="text-[12.5px] font-light text-ink-muted leading-[1.68]">{w.b}</p>
              </div>
            ))}
          </div>

          {/* Arrival band */}
          <div
            className="border border-line border-t-0 flex flex-wrap items-center justify-between gap-5 px-9 py-6"
            style={{ background: "#1A6B3A" }}
            data-testid="crossing-arrival"
          >
            <p className="font-serif-i italic text-[20px] text-white tracking-[-.015em]">
              Arrival: live on Amazon.de, .fr and .nl — selling.
            </p>
            <p className="font-mono text-[9.5px] tracking-[0.16em] uppercase" style={{ color: "rgba(255,255,255,.6)" }}>
              Final payment due week 12 · then run it yourself, or partner
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
